import React, { useState } from 'react'
import { TextField } from '@navikt/ds-react'
import { DashboardTabRenameProps } from 'index.d'
import styled from 'styled-components'
import { SuccessFilled, ErrorFilled } from '@navikt/ds-icons'

const MarginLeftDiv = styled.div`
  margin-left: 0.5rem;
`
const RenameDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
const Icon = styled.div`
  display: flex;
  cursor: pointer;
`
const DashboardTabRename: React.FC<DashboardTabRenameProps> = ({
  initialValue, handleAcceptRenameTab, handleRejectRenameTab
}: DashboardTabRenameProps): JSX.Element => {
  const [tabRenameLabel, setTabRenameLabel] = useState<string>(initialValue)
  return (
    <RenameDiv>
      <TextField
        hideLabel
        label='rename'
        size='small'
        value={tabRenameLabel}
        onChange={(e: any) => {
          e.preventDefault()
          e.stopPropagation()
          setTabRenameLabel(e.target.value)
        }}
        onClick={(e: any) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      />
      <MarginLeftDiv>
        <Icon>
          <SuccessFilled color='green' width={24} onClick={() => handleAcceptRenameTab(tabRenameLabel)} />
        </Icon>
      </MarginLeftDiv>
      <MarginLeftDiv>
        <Icon>
          <ErrorFilled color='red' width={24} onClick={() => handleRejectRenameTab()} />
        </Icon>
      </MarginLeftDiv>
    </RenameDiv>
  )
}

export default DashboardTabRename
